export default "__VITE_ASSET__BLdb6HwV__"